import { SnackbarProps } from '@material-ui/core';

export const defaultSnackbarProps: SnackbarProps = {
  open: false,
  autoHideDuration: 6000,
};
